import React from 'react'
import styles from './TagChip.module.scss'

export interface TagChipProps {
  label: string
  onRemove?: () => void
  size?: 'sm' | 'md'
}

export default function TagChip({ label, onRemove, size = 'md' }: TagChipProps) {
  return (
    <span className={`${styles.chip} ${styles[`chip--${size}`]}`}>
      <span className={styles.label}>{label}</span>
      {onRemove && (
        <button
          type="button"
          className={styles.remove}
          aria-label={`Supprimer le tag ${label}`}
          onClick={(e) => {
            e.stopPropagation()
            onRemove()
          }}
        >
          ×
        </button>
      )}
    </span>
  )
}
